<template>
<div>
    <page-title-bar></page-title-bar>
    <v-container fluid grid-list-xs pt-0>
        <v-layout row wrap justify-end align-center>
            <v-flex xs12 md10 />
            <v-flex xs12 md2>
                <v-menu
                    :close-on-content-click="false"
                    v-model="menu_month_picker"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                    :disabled="loading.submit"
                >
                    <v-text-field
                        slot="activator"
                        v-model="chosen_month"
                        label="Chọn tháng"
                        :disabled="loading.submit"
                        prepend-icon="event"
                        readonly
                    ></v-text-field>
                    <v-date-picker min="2019-10" locale="vi-VI" type="month" v-model="chosen_month" @input="menu_month_picker = false"></v-date-picker>
                </v-menu>
            </v-flex>
            <v-flex xs12 md12>
                <h3 class="">Bảng số điện bảo vệ</h3>
            </v-flex>
            <v-flex xs12 md12>
                <table-nhap-dien-nuoc-noi-bo 
                    :chosen_month="chosen_month"
                    :type="'E'"
                    :consumer_type="INTERNAL_UTILITY_CONSUMER_TYPE.SECURITY_GUARD"
                />
            </v-flex>
            <v-flex xs12 md12>
                <h3 style="margin-top: 30px;">Bảng số điện máy giặt</h3>
                <table-nhap-dien-nuoc-noi-bo 
                    :chosen_month="chosen_month"
                    :type="'E'"
                    :consumer_type="INTERNAL_UTILITY_CONSUMER_TYPE.WASHING_MACHINE"
                />
            </v-flex>                
        </v-layout>
    </v-container>
</div>
</template>
<script>
import { list_building, INTERNAL_UTILITY_CONSUMER_TYPE } from 'Constants/db-config'
import TableNhapDienNuocNoiBo from "Components/TableNhapDienNuocNoiBo/TableNhapDienNuocNoiBo";

export default {
    name: 'nhap-dien-noi-bo',
    components: {
        TableNhapDienNuocNoiBo,
    },
    data(){
        return {
            headers: [
                { text: "STT", align: "left", sortable: true, value: "index" },
                { text: "Tòa nhà", align: "left", sortable: true, value: "room_id" },
                { text: "Đầu Kì", align: "left", sortable: true, value: "start_count" },
                { text: "Cuối Kì", align: "left", sortable: true, value: "end_count" },
                { text: "Đầu Kì Sau TĐH", align: "left", sortable: true, value: "start_count_after_change_counter" },
                { text: "Cuối Kì Sau TĐH", align: "left", sortable: true, value: "end_count_after_change_counter" },
                { text: "Tiêu Thụ", align: "left", sortable: true, value: "diff_count" },
                { text: "Đơn giá", align: "left", sortable: true, value: "unit_price" },
                { text: "Thành tiền", align: "left", sortable: true, value: "unit_price" },
                { text: "Ghi Chú", align: "center", sortable: true, value: "note" },
            ],
            items: [],
            loader: false,
            rowPerPage: [{"text":"Tất cả","value":-1}, 10,20,50,100],
            chosen_month_locale: '',
            list_building,
            loading: {
                submit: false
            },
            date_check: '',
            menu_date_check: false,
            menu_month_picker: false,
            chosen_month: new Date().toISOString().substring(0, 7),
            dialog: false,
            rules: {
                required: value => !!value || 'Vui lòng điền thông tin này.',
            },
            INTERNAL_UTILITY_CONSUMER_TYPE,
        }
    },
    computed: {
        role(){
            return this.$store.state.auth.role
        }
        
    },
}
</script>

